import { AppService } from '@cation/core/services/app/app.service';
import { ChangeDetectorRef, Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '@cation/core/services/log/log.service';
import { ConversationService } from '@cation/core/services/conversation/conversation.service';
import { UserNotificationService } from '@cation/core/services/user-notification/user-notification.service';
import { AuthHelper } from '@cation/core/auth/auth-helper';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import * as _ from 'lodash';
import { ThemeService } from '@cation/core/services/theme/theme.service';
import { UrlParserService } from '@cation/core/services/url-parser/url-parser.service';
import { SidebarService } from './shared/services/sidebar.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  isSidebarCollapsed = false;

  isInternalChatEnabled = !!_.get(environment, 'internalChatConfig', false);

  @HostBinding('class.engageHub-theme') private engageHubTheme = false;
  
  private destroy$ = new Subject<void>();

  // Init Auth helper here so it's constructor subscribe to auth events
  constructor(
    private userNotificationService: UserNotificationService,
    private conversationService: ConversationService,
    public authHelper: AuthHelper,
    private translate: TranslateService,
    private logService: LogService,
    public auth: AuthHelper,
    private router: Router,
    private themeService: ThemeService,
    private urlParserService: UrlParserService,
    private appService: AppService,
    private ref: ChangeDetectorRef,
    private sidebarService: SidebarService
  ) {
    this.urlParserService.parseClient();
    this.engageHubTheme = this.urlParserService.isEngageHub;
    this.setTheme();

    translate.addLangs(['en', 'fr', 'de', 'es', 'it', 'pl']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();

    this.logService.info('[browserLang]', browserLang);

    translate.use(browserLang.match(/en|fr|de|es|it|pl/) ? browserLang : 'en');
  }
  public Authendicated
  ngOnInit(): void {
    console.log('### AppComponent::ngOnInit');

    this.authHelper.isAuthenticated$.subscribe((isAuthenticated) => {
      console.log('### AppComponent::this.authHelper.isAuthenticated$ ###', isAuthenticated);
      if (!this.isLoggedIn && isAuthenticated) setTimeout(() => this.initGlobalServices(), 0);
      this.isLoggedIn = isAuthenticated;
      // this.ref.detectChanges()
      console.log('isAuthendicated', this.isLoggedIn)
    });
    this.Authendicated = this.authHelper.isAuthenticated()
    this.authHelper.currentUserProfile$.subscribe((profile) => {
      if (profile?.cognitoId && profile.cognitoId !== 'cognitoId') {
        this.themeService.applyUserTheme(profile.cognitoId, this.engageHubTheme);
      }
    });

    this.authHelper.signOut$.subscribe(() => {
      console.log('### AppComponent::this.authHelper.signOut$ ###');
      this.router.navigate(['/login']);
    });
    
    // Subscribe to sidebar collapsed state (Requirement 6.12)
    this.sidebarService.collapsed$
      .pipe(takeUntil(this.destroy$))
      .subscribe((collapsed) => {
        this.isSidebarCollapsed = collapsed;
      });
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initGlobalServices() {
    this.userNotificationService.init();
    this.conversationService.init();
  }

  setTheme() {
    switch (true) {
      case this.engageHubTheme:
        this.themeService.setEngageHubTheme();
        // this.appService.setTitle('Engage Hub');
        this.appService.setTitle('Parly Gamification');
        break;
      default:
        this.themeService.setDefaultTheme();
        this.appService.setTitle('Parly Gamification');
    }
  }
}
